// extracted by mini-css-extract-plugin
module.exports = {"redHighlight":"Row_redHighlight__6GNXE","rightAlign":"Row_rightAlign__ewZWs"};